/**
 * Build-time configuration, written by the deploy script from OpenTofu outputs.
 * Missing values are surfaced in the UI as a setup problem rather than crashing
 * at import time — a self-hoster mid-setup should still see a helpful screen.
 */

export interface AppConfig {
  apiBaseUrl: string
  cognitoDomain: string
  cognitoClientId: string
  cognitoRedirectUri: string
  spotifyClientId: string
  spotifyRedirectUri: string
}

function fallbackRedirectUri(path: string): string {
  if (typeof window === 'undefined') return path
  return new URL(path, window.location.origin).toString()
}

export const config: AppConfig = {
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL ?? '').replace(/\/$/, ''),
  cognitoDomain: (import.meta.env.VITE_COGNITO_DOMAIN ?? '').replace(/\/$/, ''),
  cognitoClientId: import.meta.env.VITE_COGNITO_CLIENT_ID ?? '',
  cognitoRedirectUri:
    import.meta.env.VITE_COGNITO_REDIRECT_URI ?? fallbackRedirectUri('/auth/callback'),
  spotifyClientId: import.meta.env.VITE_SPOTIFY_CLIENT_ID ?? '',
  spotifyRedirectUri:
    import.meta.env.VITE_SPOTIFY_REDIRECT_URI ?? fallbackRedirectUri('/auth/spotify/callback'),
}

/** Names of the env vars that are not configured, for the setup warning. */
export function missingConfigKeys(current: AppConfig = config): string[] {
  const required: Array<[keyof AppConfig, string]> = [
    ['apiBaseUrl', 'VITE_API_BASE_URL'],
    ['cognitoDomain', 'VITE_COGNITO_DOMAIN'],
    ['cognitoClientId', 'VITE_COGNITO_CLIENT_ID'],
    ['spotifyClientId', 'VITE_SPOTIFY_CLIENT_ID'],
  ]
  return required.filter(([key]) => current[key].length === 0).map(([, envName]) => envName)
}
